const parse = (url) => {
  if (!url) return null;
  let m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([\w-]{6,})/);
  if (m) return { type: "youtube", id: m[1] };
  m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) return { type: "vimeo", id: m[1] };
  m = url.match(/tiktok\.com\/.*video\/(\d+)/);
  if (m) return { type: "tiktok", id: m[1] };
  return { type: "file", src: url };
};

export const VideoEmbed = ({ url, background = false, ad = false, className = "", testId }) => {
  const v = parse(url);
  if (!v) return null;
  const frame = "absolute inset-0 h-full w-full";
  if (v.type === "file")
    return (
      <video data-testid={testId} src={v.src} className={`${frame} object-cover ${className}`} playsInline
        {...(background ? { autoPlay: true, muted: true, loop: true } : ad ? { autoPlay: true, muted: true, loop: true, controls: true, preload: "metadata" } : { controls: true })} />
    );
  const src = {
    youtube: `https://www.youtube.com/embed/${v.id}?${background ? `autoplay=1&mute=1&loop=1&playlist=${v.id}&controls=0&playsinline=1` : "rel=0"}`,
    vimeo: `https://player.vimeo.com/video/${v.id}${background ? "?background=1" : ""}`,
    tiktok: `https://www.tiktok.com/embed/v2/${v.id}`,
  }[v.type];
  return (
    <iframe data-testid={testId} src={src} title="Grandpa Finn video" className={`${frame} ${background ? "pointer-events-none scale-[1.35]" : ""} ${className}`}
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen />
  );
};
